export const weightUnits = [
  {
    label: 'kilogramos',
    value: 'kg',
  },
  {
    label: 'gramos',
    value: 'g',
  },
  {
    label: 'libras',
    value: 'lb',
  },
  {
    label: 'onzas',
    value: 'oz',
  },
]
